module.exports = __webpack_public_path__ + "static/media/-_Organization Management.a7681f33.png";